<template>
    <div :aria-labelledby="name" class="bg-white rounded-md shadow-md relative inline-flex flex-row w-fit my-2 h-auto">
        <div ref="indicator" class="absolute top-0 bottom-0 p-1 w-full h-full rounded-md pointer-events-none transition-all ease-in-out">
            <div class="indicator w-full h-full rounded-md" />
        </div>
        <div ref="toggles" class="inline-flex flex-row">
            <div
                v-for="(choice, index) in choices"
                :key="index"
                @click="toggle(index)"
                :class="[index === active ? 'active' : '', toggleClass]"
                class="p-3 z-10 cursor-pointer choice"
            >
                <slot name="choice" :data="choice"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['choices', 'active', 'color', 'colorGradient', 'name', 'toggleClass'],
    emits: ['update:active'],

    mounted() {
        this.$nextTick(() => {
            this.indicator();
        });

        window.addEventListener('resize', this.indicator);
    },

    beforeUnmount() {
        window.removeEventListener('resize', this.indicator);
    },

    methods: {
        toggle(index) {
            this.$emit('update:active', index);
        },
        indicator() {
            let parentEl = this.$refs.toggles;
            let el = this.$refs.toggles?.childNodes[this.active + 1];

            if (el && parentEl) {
                let parent = parentEl.getBoundingClientRect();
                let child = el.getBoundingClientRect();

                this.$refs.indicator.style.right = child.right - parent.right + 'px';
                this.$refs.indicator.style.left = child.left - parent.left + 'px';
                this.$refs.indicator.style.width = el.clientWidth + 'px';
                this.$refs.indicator.style.height = el.clientHeight + 'px';
            }
        }
    },

    watch: {
        active: function () {
            this.$nextTick(() => {
                this.indicator();
            });
        }
    },

    computed: {
        background() {
            return 'linear-gradient(to bottom, ' + this.color + ' 0%, ' + this.colorGradient + ' 100%)';
        },
        textColor() {
            return this.color;
        }
    }
};
</script>

<style scoped>
.indicator {
    background: v-bind(background);
    color: white;
}
.choice {
    background: transparent;
    color: v-bind(textColor);
}
.choice.active {
    background: transparent;
    color: white;
}
</style>
